<template>
  <div class="container-fluid p-1 position-relative ">
    <div class="row">
      <div class="d-flex justify-content-between w-100">
        <div class="px-1">
          <router-link
            :to="{ name: 'BatchParticipantsID', params: { id: course_id } }"
            class="btn bg-gradient-info top-button"
          >
            <i class="bi bi-arrow-left-circle"></i> &nbsp;&nbsp;Back
          </router-link>
        </div>
      </div>
    </div>
  </div>
  
  <div class="row">
    <div class="col-12">
      <div class="card my-4">
        <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2  mb-4">
          <div
            class="row bg-gradient-info shadow-black border-radius-lg pt-4 pb-3 mb-3"> 
            <h6 class="col text-white text-capitalize ps-3">Participants - Registration Page</h6>
          </div>
          
          <Loading message="Loading registration page" :loading = "loading"/>
          
          <div v-if="loading == false">
            <iframe :src="lp_url_from_course" width="100%" height="800px"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http, url_from_app_user } from "../http/index";
import Loading from "@/views/components/Loading.vue";


export default {
  name: "RegistrationPage",

  components : {
    Loading    
  },  

  data() {
    return {
      loading: true,
      lp_url_from_course: null,
      course_id: this.$route.params.id,
      token_user: localStorage.getItem("token"),
    };
  },

  mounted() {
    this.getCourseRegistrationPageInfo()
  },

  methods: {
    getCourseRegistrationPageInfo() {
      let payload = {
        token_user: this.token_user,
        course_id: this.course_id
      }
      
      http.post('/api/v1/dashboard/get-course-registration-page-info/', payload)
      .then((response) => {
        this.data_api_course_info = response.data
        var course_external_exercise_id = this.data_api_course_info.data.course_external_exercise_id
        var is_private = this.data_api_course_info.data.registration_page_is_private
        if (is_private){
          this.lp_url_from_course = url_from_app_user + course_external_exercise_id + "/access/" + this.token_user;
        }else{
          this.lp_url_from_course = url_from_app_user + course_external_exercise_id;
        }
      })          
      .finally(() => {
        this.loading = false        
      });
    }
  }
}
</script>

<style scoped>
  .top-button {
    margin: 0px 0px 10px;
  }
</style>
